const colourControls = document.querySelector('[data-color-controls]');
const colourToggle = colourControls?.querySelector('[data-color-toggle]');
let coloursPaused = false;
try { coloursPaused = sessionStorage.getItem('bac-colours-paused') === 'true'; } catch {}
function syncColourControl() {
  if (!colourToggle) return;
  colourToggle.textContent = coloursPaused ? colourToggle.dataset.playLabel : colourToggle.dataset.pauseLabel;
  colourToggle.setAttribute('aria-pressed', String(coloursPaused));
}
colourToggle?.addEventListener('click', () => {
  coloursPaused = !coloursPaused;
  try { sessionStorage.setItem('bac-colours-paused', String(coloursPaused)); } catch {}
  syncColourControl();
  document.dispatchEvent(new Event('bac-colours-toggle'));
});
syncColourControl();

class BacColorRotation extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.gallery = this.closest('.card-gallery');
    this.card = this.closest('product-card') || this.gallery;
    this.caption = this.querySelector('[data-color-name]');
    try { this.items = JSON.parse(this.querySelector('script').textContent || '[]'); } catch { return; }
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.index = 0;
    this.visible = false;
    this.interacted = false;
    const seed = Number(this.gallery.dataset.productId.slice(-6));
    this.delay = 6200 + seed % 13 * 173;
    this.card.addEventListener('pointerenter', () => this.stop(), { signal });
    this.card.addEventListener('pointerleave', () => this.sync(), { signal });
    this.card.addEventListener('focusin', () => this.stop(), { signal });
    this.card.addEventListener('focusout', () => queueMicrotask(() => this.sync()), { signal });
    const cancelPreview = () => {
      this.interacted = true;
      this.caption.hidden = true;
      this.preview?.remove();
      this.preview = undefined;
      this.sync();
    };
    this.card.addEventListener('change', cancelPreview, { signal });
    this.card.addEventListener('pointerdown', (event) => {
      if (event.target.closest('slideshow-arrows, swatches-variant-picker-component')) cancelPreview();
    }, { signal });
    this.card.addEventListener('click', (event) => {
      if (event.target.closest('slideshow-arrows')) cancelPreview();
    }, { signal });
    for (const event of ['visibilitychange', 'bac-colours-toggle']) document.addEventListener(event, () => this.sync(), { signal });
    this.motion.addEventListener('change', () => this.sync(), { signal });
    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.sync();
    }, { threshold: 0.3 });
    this.observer.observe(this.gallery);
    customElements.whenDefined('slideshow-component').then(() => {
      if (!this.isConnected) return;
      this.slideshow = this.gallery.querySelector('slideshow-component');
      this.items = this.items.filter((item) => this.slideshow?.querySelector(`slideshow-slide[slide-id="${item.mediaId}"]`));
      if (this.items.length < 2) return;
      this.index = Math.max(0, this.items.findIndex(item => item.mediaId === this.dataset.initialMedia));
      const gcd = (a,b) => b ? gcd(b,a % b) : a;
      this.step = 1 + seed % (this.items.length - 1);
      while (gcd(this.step,this.items.length) !== 1) this.step = this.step % (this.items.length - 1) + 1;
      this.caption.textContent = this.items[this.index].color;
      if (colourControls) colourControls.hidden = false;
      this.sync();
    });
  }

  stop() {
    clearTimeout(this.timer);
    this.timer = undefined;
  }

  canAdvance() {
    return this.isConnected && this.slideshow && this.items.length > 1 && this.visible && !coloursPaused && !this.interacted && !this.motion.matches && !document.hidden && !this.card.matches(':hover, :focus-within');
  }

  sync() {
    this.stop();
    if (this.canAdvance()) this.timer = setTimeout(() => this.advance(), this.delay);
  }

  async advance() {
    if (!this.canAdvance()) return;
    const nextIndex = (this.index + this.step) % this.items.length;
    const item = this.items[nextIndex];
    const image = this.slideshow.querySelector(`slideshow-slide[slide-id="${item.mediaId}"] img`);
    if (!image) { this.sync(); return; }
    image.loading = 'eager';
    try { await image.decode(); } catch { this.sync(); return; }
    if (!this.canAdvance()) { this.sync(); return; }
    const nextPreview = image.cloneNode(false);
    nextPreview.removeAttribute('id');
    nextPreview.removeAttribute('ref');
    nextPreview.classList.add('bac-color-preview');
    nextPreview.style.objectFit = getComputedStyle(image).objectFit;
    this.preview?.remove();
    this.preview = nextPreview;
    this.gallery.querySelector('[ref="cardGalleryLink"]').append(nextPreview);
    this.index = nextIndex;
    this.caption.textContent = item.color;
    this.dataset.currentColor = item.color;
    this.sync();
  }

  disconnectedCallback() {
    this.stop();
    this.controller?.abort();
    this.observer?.disconnect();
    this.preview?.remove();
    this.preview = undefined;
    this.controller = undefined;
  }
}
if (!customElements.get('bac-color-rotation')) customElements.define('bac-color-rotation', BacColorRotation);
